export const getCareerOptionLearnMoreInteraction = (name: string) => {
  const splitStr = name.toLowerCase().split(' ')
    .map(item => item.charAt(0).toUpperCase() + item.substring(1));
  const joinedName = splitStr.join('').replace(',', '');
  return 'learnMore'.concat(joinedName);
};
